import { __awaiter } from "tslib";
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Alert from '@/components/alert';
import Timer from '@/components/timer';
import { getAuth0Audience } from '@/auth/utilities';
import { LocalizedMessage } from '@/localization';
import { SESSION_INACTIVE_TIMEOUT } from '@/constants';
import { useAuthLogout } from '@/auth/hooks/authentication';
import { getTenantName } from '@/utils';
import { logError } from '@/utils/logger';
const IdleAlert = ({ isInactive, onActive }) => {
    const tenantName = getTenantName();
    const { logout } = useAuthLogout();
    const { getAccessTokenSilently } = useAuth0();
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield getAccessTokenSilently({
                cacheMode: 'off',
                authorizationParams: {
                    audience: getAuth0Audience(tenantName),
                },
            });
            onActive();
        }
        catch (error) {
            logError('Failed to refresh token on stay-logged-in', error);
            // Token refresh failed (e.g. refresh token expired during idle period).
            // Log the user out gracefully instead of leaving them in a broken state.
            void logout();
        }
    });
    const handleLogout = () => {
        void logout();
    };
    return (<Alert title={<span>
          <LocalizedMessage messageKey="LOGIN_SESSION_TIMEOUT_IN"/>
          {' '}
          <Timer timeout={SESSION_INACTIVE_TIMEOUT} onComplete={handleLogout}/>
        </span>} primaryButton={{
            label: <LocalizedMessage messageKey="LOGIN_SESSION_STAY_LOGGED_IN"/>,
            onClick: handleClick,
        }} cancelLabel={<LocalizedMessage messageKey="LOGIN_SESSION_LOGOUT"/>} open={isInactive} onCancel={handleLogout}/>);
};
export default IdleAlert;
